/**
 * represent the Discount with its code
 */
const DiscountService = function ($sce) {

  return {
    item: null,
    code: '',
    showInfo: false,
    error: {
      discountInfoLink: '',
      discountInfoData: ''
    },

    resetItem: function () {
      this.item = null;
      this.code = '';
    },
    setItem: function (item) {
      this.item = item;
      this.code = item.identifier;
    },

    /**
     * @return {*}
     */
    getInfoLink: function () {
      return $sce.trustAsHtml(
        '<a href="#discount-modal" class="modalTrigger discount">' + this.error.discountInfoLink + '</a>' +
        '<script type="text/javascript">$(\'.modalTrigger.discount\').leanModal({closeButton: \'.close\'});</script> '
      );
    },

    setError: function (item) {
      this.error.discountInfoLink = item.discountInfoLink;
      this.error.discountInfoData = item.discountInfoData;
    },

    /**
     * @param $scope
     * @param item
     */
    setDiscount: function (item, $scope) {
      if (!item.identifier || item.error) {
        if (item.error) {
          var error = item.error;
          this.error.discountInfoLink = '';
          this.error.discountInfoData = '';
          if (item.discountInfoLink) {
            this.setError(item);
            error += ' ' + this.getInfoLink();
          }
          $scope.displayError(error);
        }
        this.resetItem();
        if ($scope.cartItems) {
          delete $scope.cartItems[ 'product' + '-' + item.id ];
        }
        return;
      }

      this.setItem(item);

      item.productid = item.id;
      $scope.cartItems[ 'product' + '-' + item.id ] = item;

      $scope.showVoucherForm = false;

      $scope.scrollCartToBottom();
      $scope.updateCartSum();

    }
  };
};


export default DiscountService;
